import React, { FC } from 'react';
import { GraniteButton } from 'components/V2/Button/GraniteButton';
import FileAnimation from './FileAnimation';

export interface UploaderContentProps {
  hovered: boolean;
  isDragOver: boolean;
}

const UploaderContent: FC<UploaderContentProps> = ({ hovered, isDragOver }) => {
  return (
    <>
      <FileAnimation hovered={hovered || isDragOver} />
      <p className="mb-0.5 mt-6 text-[20px] font-bold leading-7 text-content-base-default">
        Drag & drop or click to upload
      </p>
      <p className="mb-2.5 text-xs font-medium text-content-base-subdued">
        Supported formats: CSV, Excel, PDF, PNG or TXT. Max size 25 MB.
      </p>
      <GraniteButton size="small" variant="secondary">
        Select file
      </GraniteButton>
    </>
  );
};

export default UploaderContent;
